import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-any',
  templateUrl: './ab-any.component.html',
  styleUrls: ['./ab-any.component.scss']
})
export class AbAnyComponent implements OnInit {

 @Input() element: any;

  constructor() { }

  ngOnInit(): void {
  }

}
